import values from 'lodash/values';

import * as pageEventsListener from './pageEventsListener';

export default [...values(pageEventsListener)];
